export enum OrderOptimizerListParamsStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

type OrderOptimizerListParams = {
  orderHumanId?: number;
  page?: number;
  pageSize?: number;
  maximumDelay?: number;
  maximumHaltingTime?: number;
  mergePlanEntries?: boolean;
  ignoreTaxi?: string[];
  ignoreOnlyWithTaxi?: string[];
  ignoreCargo?: string[];
  ignoreOnlyWithCargo?: string[];
  status?: OrderOptimizerListParamsStatus;
  excludeStatus?: OrderOptimizerListParamsStatus;
};

export default OrderOptimizerListParams;
